import { reducerWithInitialState } from "typescript-fsa-reducers";
import { State } from "./favourite-url.types";
import * as actions from "./favourite-url.actions";

export const initialState: Readonly<State> = {
  isFavouriteUrlLoading: false,
  favouriteUrl: undefined,
  favouriteUrlList: [],
  favouriteUrlSuccess: undefined,
};

export default reducerWithInitialState(initialState)
  .case(actions.resetFavouriteUrl, () => ({ ...initialState }))
  .case(actions.favouriteUrl, (state, { favouriteUrl }) => ({
    ...state,
    favouriteUrl,
  }))
  .case(actions.isFavouriteUrlLoading, (state, { isFavouriteUrlLoading }) => ({
    ...state,
    isFavouriteUrlLoading,
  }))
  .case(actions.favouriteUrlList, (state, { favouriteUrlList }) => ({
    ...state,
    favouriteUrlList,
  }))
  .case(actions.favouriteUrlSuccess, (state, { favouriteUrlSuccess }) => ({
    ...state,
    favouriteUrlSuccess,
  }))
  .build();
